module.exports = __webpack_public_path__ + "img/ventajas1.cd01d943.png";